import React from 'react';
import { TaskFormItem_VOLUNTEER_TaskItemFieldType_field as TaskItemFieldType } from '../../../../../../../../../common/form/task-form/model/__generated__/TaskFormItem';
import { AttachmentFieldPreview } from './AttachmentFieldPreview';
import { CheckboxFieldPreview } from './CheckboxFieldPreview';
import { CrossTaskDynamicFieldPreview } from './CrossTaskDynamicFieldPreview';
import { DropdownFieldPreview } from './DropdownFieldPreview';
import { MultipleChoiceFieldPreview } from './MultipleChoiceFieldPreview';
import { QuizFieldPreview } from './QuizFieldPreview';
import { TextFieldPreview } from './TextFieldPreview';
import { SignatureFieldPreview } from './SignatureFieldPreview';
import { RatingFieldPreview } from './RatingFieldPreview';
import { YesNoFieldPreview } from './YesNoFieldPreview';
import { LinearScaleFieldPreview } from './LinearScaleFieldPreview';
import { NpsFieldPreview } from './NpsFieldPreview';

interface TaskItemFieldProps {
  field: TaskItemFieldType;
  isDragging: boolean;
}

export function TaskItemField({ field, isDragging }: TaskItemFieldProps) {
  switch (field.__typename) {
    case 'VOLUNTEER_ShortTextTaskFieldType':
    case 'VOLUNTEER_LongTextTaskFieldType':
    case 'VOLUNTEER_NumberTaskFieldType':
    case 'VOLUNTEER_DateTaskFieldType':
    case 'VOLUNTEER_TimeTaskFieldType':
    case 'VOLUNTEER_AddressTaskFieldType':
    case 'VOLUNTEER_EmailTaskFieldType':
    case 'VOLUNTEER_UrlTaskFieldType':
    case 'VOLUNTEER_PhoneTaskFieldType':
      return <TextFieldPreview />;
    case 'VOLUNTEER_AttachmentTaskFieldType':
      return <AttachmentFieldPreview />;
    case 'VOLUNTEER_MultipleChoiceTaskFieldType':
      return <MultipleChoiceFieldPreview field={field} isDragging={isDragging} />;
    case 'VOLUNTEER_CheckboxTaskFieldType':
      return <CheckboxFieldPreview field={field} isDragging={isDragging} />;
    case 'VOLUNTEER_DropdownTaskFieldType':
      return <DropdownFieldPreview field={field} isDragging={isDragging} />;
    case 'VOLUNTEER_QuizTaskFieldType':
      return <QuizFieldPreview field={field} isDragging={isDragging} />;
    case 'VOLUNTEER_SignatureTaskFieldType':
      return <SignatureFieldPreview />;
    case 'VOLUNTEER_RatingTaskFieldType':
      return <RatingFieldPreview />;
    case 'VOLUNTEER_YesNoTaskFieldType':
      return <YesNoFieldPreview />;
    case 'VOLUNTEER_LinearScaleTaskFieldType':
      return (
        <LinearScaleFieldPreview
          minValue={field.minValue}
          maxValue={field.maxValue}
          minLabel={field.minLabel}
          maxLabel={field.maxLabel}
        />
      );
    case 'VOLUNTEER_NpsTaskFieldType':
      return <NpsFieldPreview />;
    case 'VOLUNTEER_CrossTaskDynamicTaskFieldType':
      return <CrossTaskDynamicFieldPreview field={field} isDragging={isDragging} />;
    default:
      return null;
  }
}
